import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import useSWR from 'swr';
import { TransformationIssueWithData } from '../../../../../../../typings/Issue.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../utils';
import { RelativeDate } from '../../../../utils/date';
import Button from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Loading from '../../../common/base/Loading';
import Skeleton from '../../../common/base/Skeleton';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import Editor from '../../../common/Editor';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import Console from '../Connections/Forms/TransformRuleForm/Console';
import Histogram from '../Events/Histogram';
import { CollapsableDataSection } from '../../../common/Data/CollapsableDataSection';
import Link from '../../../common/base/Link';
import { BulkOperationProgress } from '../../../common/BulkOperations';
interface Query {
  tab: string;
  selected_execution_id?: string | string[];
  next?: string;
  prev?: string;
}
const TransformationIssue: React.FC<{
  issue: TransformationIssueWithData;
  setDate: (query_date: object) => void;
  start_date: Date;
  end_date: Date;
  relative_date?: RelativeDate;
  refresh_key: string;
}> = t0 => {
  const $ = _c(72);
  const {
    issue,
    start_date,
    end_date,
    setDate,
    relative_date,
    refresh_key
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== issue.aggregation_keys.log_level) {
    t1 = issue.aggregation_keys.log_level.includes("fatal");
    $[0] = issue.aggregation_keys.log_level;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const is_fatal = t1;
  const tab = !is_fatal ? "executions" : query.tab || "ignored";
  const {
    transformation_execution
  } = issue.data;
  let t2;
  if ($[2] !== query.selected_execution_id || $[3] !== transformation_execution.id) {
    t2 = extractFromArray(query.selected_execution_id) as string || transformation_execution.id;
    $[2] = query.selected_execution_id;
    $[3] = transformation_execution.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selected_execution_id = t2;
  let t3;
  if ($[5] !== transformation_execution.transformation_id) {
    t3 = APIMethodKeys.transformations.get(transformation_execution.transformation_id);
    $[5] = transformation_execution.transformation_id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== HookdeckAPI.transformations || $[8] !== transformation_execution.transformation_id) {
    t4 = () => HookdeckAPI.transformations.get(transformation_execution.transformation_id);
    $[7] = HookdeckAPI.transformations;
    $[8] = transformation_execution.transformation_id;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: transformation
  } = useSWR(t3, t4);
  let t5;
  if ($[10] !== selected_execution_id || $[11] !== transformation_execution.transformation_id) {
    t5 = selected_execution_id && APIMethodKeys.transformations.getExecution(transformation_execution.transformation_id, selected_execution_id);
    $[10] = selected_execution_id;
    $[11] = transformation_execution.transformation_id;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== HookdeckAPI.transformations || $[14] !== selected_execution_id || $[15] !== transformation_execution.transformation_id) {
    t6 = () => HookdeckAPI.transformations.getExecution(transformation_execution.transformation_id, selected_execution_id);
    $[13] = HookdeckAPI.transformations;
    $[14] = selected_execution_id;
    $[15] = transformation_execution.transformation_id;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const {
    data: execution
  } = useSWR(t5, t6);
  const [collapse_console, setCollapseConsole] = useState(false);
  const [collapse_input, setCollapseInput] = useState(false);
  const t7 = issue.id;
  const t8 = transformation_execution.transformation_id;
  let t9;
  if ($[17] !== start_date) {
    t9 = start_date.toISOString();
    $[17] = start_date;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== end_date) {
    t10 = end_date.toISOString();
    $[19] = end_date;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== relative_date || $[22] !== t10 || $[23] !== t9) {
    t11 = {
      relative: relative_date,
      min: t9,
      max: t10
    };
    $[21] = relative_date;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== issue.id || $[26] !== t11 || $[27] !== transformation_execution.transformation_id) {
    t12 = {
      issue_id: t7,
      transformation_id: t8,
      date: t11
    };
    $[25] = issue.id;
    $[26] = t11;
    $[27] = transformation_execution.transformation_id;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const filters = t12;
  let t13;
  if ($[29] !== issue.aggregation_keys.transformation_id[0]) {
    t13 = APIMethodKeys.bulk.ignored_events.list({
      query: {
        transformation_id: issue.aggregation_keys.transformation_id[0]
      },
      query_partial_match: true,
      in_progress: true
    });
    $[29] = issue.aggregation_keys.transformation_id[0];
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== HookdeckAPI.bulk.ignored_events || $[32] !== issue.aggregation_keys.transformation_id[0]) {
    t14 = () => HookdeckAPI.bulk.ignored_events.list({
      query: {
        transformation_id: issue.aggregation_keys.transformation_id[0]
      },
      query_partial_match: true,
      in_progress: true
    });
    $[31] = HookdeckAPI.bulk.ignored_events;
    $[32] = issue.aggregation_keys.transformation_id[0];
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      refreshInterval: 5000
    };
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const {
    data: current_bulk_retries
  } = useSWR(t13, t14, t15);
  const current_bulk_retry = current_bulk_retries?.models && current_bulk_retries.models.length > 0 && current_bulk_retries?.models[0];
  if (!transformation) {
    let t16;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        justify: "center"
      };
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    let t17;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Div flex={t16} p={8}><Loading /></Div>;
      $[36] = t17;
    } else {
      t17 = $[36];
    }
    return t17;
  }
  let t16;
  if ($[37] !== current_bulk_retry) {
    t16 = current_bulk_retry && <StyledCard m={{
      b: 8
    }}><StyledCardSection p={{
        x: 4,
        y: 3
      }}><Text semi={true}>Bulk retry in progress</Text></StyledCardSection><StyledCardSection p={4}><BulkOperationProgress operation_type="retry" model="ignored_events" operation={current_bulk_retry} /></StyledCardSection></StyledCard>;
    $[37] = current_bulk_retry;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Text bold={true} size="l" m={{
      b: 4
    }}>Histogram</Text>;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== is_fatal || $[41] !== tab || $[42] !== updateSearchQuery) {
    t18 = is_fatal && <StyledCardSection p={{
      x: 4,
      t: 2
    }}><Tabs compact={true} border={false} active_tab={tab} tabs={[{
        label: "Ignored Events",
        key: "ignored"
      }, {
        label: "Executions",
        key: "executions"
      }]} onTabSelected={tab_0 => updateSearchQuery({
        tab: tab_0
      })} /></StyledCardSection>;
    $[40] = is_fatal;
    $[41] = tab;
    $[42] = updateSearchQuery;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== end_date || $[45] !== filters || $[46] !== issue.id || $[47] !== refresh_key || $[48] !== setDate || $[49] !== start_date || $[50] !== tab) {
    t19 = tab === "executions" && <><StyledCardSection p={{
        x: 4,
        y: 3
      }}><Histogram model="EventRequestsTransformations" dimention="log_level" filters={filters} start_date={start_date} end_date={end_date} setDate={setDate} allow_reset={false} refresh_key={refresh_key} show_date_filter={true} /></StyledCardSection><StyledCardSection flex={{
        align: "center",
        justify: "space-between"
      }} p={{
        x: 4,
        y: 2
      }}><Text muted={true}>Transformation executions that resulted in this issue.</Text><Button ghost={true} primary={true} to={`/issues/${issue.id}/executions`}>View executions {"->"}</Button></StyledCardSection></>;
    $[44] = end_date;
    $[45] = filters;
    $[46] = issue.id;
    $[47] = refresh_key;
    $[48] = setDate;
    $[49] = start_date;
    $[50] = tab;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== end_date || $[53] !== filters || $[54] !== refresh_key || $[55] !== setDate || $[56] !== start_date || $[57] !== tab) {
    t20 = tab === "ignored" && <><StyledCardSection p={{
        x: 4,
        y: 3
      }}><Histogram model="IgnoredEvents" dimention="cause" filters={{
          date: filters.date,
          cause: ["TRANSFORMATION_FAILED"]
        }} start_date={start_date} end_date={end_date} setDate={setDate} allow_reset={false} refresh_key={refresh_key} show_date_filter={true} /></StyledCardSection><StyledCardSection p={{
        x: 4,
        y: 3
      }}><Text muted={true}>Ignored events represent events not processed because of the transformation failure. Bulk retring the transformation will retry all matching ignored events.</Text></StyledCardSection></>;
    $[52] = end_date;
    $[53] = filters;
    $[54] = refresh_key;
    $[55] = setDate;
    $[56] = start_date;
    $[57] = tab;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== t18 || $[60] !== t19 || $[61] !== t20) {
    t21 = <StyledCard>{t18}{t19}{t20}</StyledCard>;
    $[59] = t18;
    $[60] = t19;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Text bold={true} size="l" m={{
      t: 10,
      b: 4
    }}>Execution details</Text>;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== collapse_console || $[65] !== collapse_input || $[66] !== execution) {
    t23 = !execution ? <><Skeleton h={{
        px: 20
      }} w={{
        px: 200
      }} m={{
        b: 4
      }} /><Skeleton h={{
        px: 100
      }} m={{
        b: 10
      }} /><Skeleton h={{
        px: 20
      }} w={{
        px: 200
      }} m={{
        b: 4
      }} /><Skeleton h={{
        px: 300
      }} /></> : <><Div m={{
        t: 4
      }}><CollapsableDataSection embedded={false} collapsed={collapse_console}><Text semi={true} onClick={() => setCollapseConsole(!collapse_console)}>Console output</Text><Link neutral={true} icon={collapse_console ? "chevron_down" : "chevron_up"} onClick={() => setCollapseConsole(!collapse_console)} /></CollapsableDataSection>{!collapse_console && <StyledCard overflow_hidden={true} m={{
          b: 8
        }}><Console.Container lines={execution.logs} dynamic_height={true} /></StyledCard>}</Div><Div m={{
        t: 4
      }}><CollapsableDataSection embedded={false} collapsed={collapse_input}><Text semi={true} onClick={() => setCollapseInput(!collapse_input)}>Execution input</Text><Link neutral={true} icon={collapse_input ? "chevron_down" : "chevron_up"} onClick={() => setCollapseInput(!collapse_input)} /></CollapsableDataSection>{!collapse_input && <StyledCard overflow_hidden={true}><StyledCardSection muted={true} p={2}><Editor height="50vh" value={JSON.stringify(execution.original_event_data, null, 2)} disabled={true} options={{
              scrollBeyondLastLine: false
            }} /></StyledCardSection></StyledCard>}</Div></>;
    $[64] = collapse_console;
    $[65] = collapse_input;
    $[66] = execution;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  let t24;
  if ($[68] !== t16 || $[69] !== t21 || $[70] !== t23) {
    t24 = <>{t16}{t17}{t21}{t22}{t23}</>;
    $[68] = t16;
    $[69] = t21;
    $[70] = t23;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  return t24;
};
export default TransformationIssue;